import React from 'react';
import styled from 'styled-components';
import {
  socialEnterpriseUK,
  verifiedCarbonStandard,
  carbonNeutral,
  isoCertificate,
  socialEnterpriseUKSmall,
  verifiedCarbonStandardSmall,
} from '../../../Assets/Footer';
import { tabletMediaQuery, useBreakPoints } from '../../../Theming';

const SocialEnterpriseUK = styled.img`
  width: 110px;
  height: 110px;

  ${tabletMediaQuery} {
    width: 28px;
    height: 20px;
  }
`;

const StyledVerifiedCarbon = styled.img`
  width: 80px;
  height: 22px;
  margin-right: 11px;

  ${tabletMediaQuery} {
    width: 24px;
    height: 25px;
  }
`;

const StyledCarbonNeutral = styled.img`
  width: 24px;
  height: 37px;
  margin-right: 11px;

  ${tabletMediaQuery} {
    margin-right: 8px;
  }
`;

const StyledISOCert = styled.img`
  width: 37px;
  height: 20px;
  margin-right: 11px;

  ${tabletMediaQuery} {
    margin-right: 8px;
  }
`;

const Logos: React.FC = () => {
  const { tablet } = useBreakPoints();

  return (
    <>
      <StyledISOCert src={isoCertificate} alt={'Social Enterprise UK Logo'} />
      <StyledCarbonNeutral src={carbonNeutral} alt={'Carbon Neutral Logo'} />
      <StyledVerifiedCarbon
        src={tablet ? verifiedCarbonStandardSmall : verifiedCarbonStandard}
        alt={'Verified Standard Logo'}
      />
      <SocialEnterpriseUK
        src={tablet ? socialEnterpriseUKSmall : socialEnterpriseUK}
        alt={'Social Enterprise UK Logo'}
      />
    </>
  );
};

export default Logos;
